import React from 'react';

import NotificationList from '.';

const TroyNotificationList = props => <NotificationList {...{ ...props }} />;

export default TroyNotificationList;
